import { all, takeLatest, put } from 'redux-saga/effects';
import { requestCountryStatisticsCalendar } from './api';
import { statisticsCountryCalendarSuccess } from './actions';

import {
    STATISTICS_COUNTRY
} from './constants';

/**
 *
 * @param action
 * @returns {IterableIterator<PutEffect<*>>}
 */
function* getCountryCalendarStatistics( action ) {
    const cstatistic = yield requestCountryStatisticsCalendar( action.calendarID );

    if ( cstatistic ) {
        yield put( statisticsCountryCalendarSuccess( cstatistic ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchCountryCalendarStatistics() {
    yield  takeLatest( STATISTICS_COUNTRY, getCountryCalendarStatistics );
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* calendarCountryStatisticsSaga() {
    yield all( [
        watchCountryCalendarStatistics()
    ] );
}

export default calendarCountryStatisticsSaga;